import { useRouter } from '@/router'
import store from '@/store'
import Cookies from 'js-cookie'
import { Modal } from 'ant-design-vue'

const router = useRouter()

router.beforeEach(async (to, from, next) => {
  // 对所有的目标进行ac参数检查
  if ('x-jczh-ac' in to.query) {
    const domain = `.${window.location.hostname.split('.').slice(-2).join('.')}`

    if (to.query['x-jczh-ac']) {
      Cookies.set('X-PURCHASE-AC', to.query['x-jczh-ac'], {
        domain: domain
      })
      Cookies.set('X-JCZH-AC', to.query['x-jczh-ac'], {
        domain: domain
      })
    } else {
      Cookies.remove('X-PURCHASE-AC', { domain: domain })
      Cookies.remove('X-JCZH-AC', { domain: domain })
    }

    delete to.query['x-jczh-ac']
    next(to)
  }

  try {
    // 如果是访问公开页面，则放行
    if (to.meta?.pageType === 'public') {
      next()
      return
    }
    // 如果是访问非公开页面，则需要检查登录状态
    const isLogin = store.state.user.isLogin
    if (!isLogin) {
      await store.dispatch('user/checkLogin')
    }
    next()
  } catch (e) {
    console.error('router beforeEach error: ', e)
    Modal.confirm({
      title: '您还未登录，请先登录',
      icon: 'exclamation-circle',
      onOk: () => {
        store.dispatch('user/logout')
      },
      onCancel: () => {}
    })
  }
})

router.afterEach((to, from) => {
  store.commit('cacheView/ADD_CACHED_VIEW', to)
  store.commit('cacheView/INIT_HISTORY_LENGTH')
  store.commit('cacheView/ADD_HISTORY_LENGTH', to)
})

router.goBack = () => {
  const historyLength = store.state.cacheView.historyLength
  if (historyLength <= 1) {
    router.replace({
      name: 'Home'
    })
    return
  }
  store.commit('cacheView/DEL_CACHED_VIEW', router.currentRoute.name)
  store.commit('cacheView/DEL_HISTORY_LENGTH')
  router.back()
}
